import { ResetPasswordForm, ResetPasswordFormData } from '@features/user/auth';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminResetPassword } from '@src/services/adminAuth.ts';

export const AdminResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleResetPassword = useCallback(
    async (data: ResetPasswordFormData) => {
      try {
        await adminResetPassword({
          newPassword: data.password,
        });
        navigate('/admin/signin');
      } catch {
        toast.error(t('toast.failedToResetPassword'));
      }
    },
    [navigate, t]
  );

  return (
    <ResetPasswordForm
      className={
        'bg-[#242C36] px-[40px] lg:px-[93px] py-[50px]  w-full lg:w-[584px]'
      }
      onSubmit={handleResetPassword}
    />
  );
};
